import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, PhoneCall } from "lucide-react";
import { siteContent } from "../content/siteContent";

const Hero = () => {
  const h = siteContent.hero;
  return (
    <section className="relative min-h-[92vh] flex items-center overflow-hidden pt-20">
      {/* Background */}
      <div className="absolute inset-0">
        <img src={h.backgroundImage} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur px-4 py-1.5 rounded-full border border-cyan-200 mb-6 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-[#22b8db] animate-pulse" />
            <span className="text-[#1a3a6e] text-xs font-semibold tracking-wider uppercase">
              {h.kicker}
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl font-extrabold text-[#1a3a6e] leading-[1.05] tracking-tight">
            {h.titleTop}
            <br />
            {h.titleBottom}
          </h1>

          <div className="mt-6 text-2xl md:text-3xl font-bold text-[#1a3a6e]">
            {h.subtitle}
          </div>

          <p className="mt-5 text-slate-600 text-[15.5px] leading-relaxed max-w-xl">
            {h.description}
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <Link
              to={h.primaryCta.to}
              className="inline-flex items-center gap-2 bg-[#1a3a6e] hover:bg-[#12295a] text-white px-8 py-4 rounded-md font-semibold text-sm tracking-wide transition-colors shadow-lg"
            >
              {h.primaryCta.label} <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to={h.secondaryCta.to}
              className="inline-flex items-center gap-2 bg-white hover:bg-[#22b8db] hover:text-white text-[#1a3a6e] border-2 border-[#22b8db] px-8 py-4 rounded-md font-semibold text-sm tracking-wide transition-colors shadow-sm"
            >
              {h.secondaryCta.label}
            </Link>
          </div>

          <a
            href={siteContent.contact.phoneHref}
            className="mt-10 inline-flex items-center gap-3 text-[#1a3a6e] group"
          >
            <div className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center text-[#22b8db] group-hover:bg-[#22b8db] group-hover:text-white transition-colors">
              <PhoneCall className="w-5 h-5" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-slate-500">
                Call us anytime
              </div>
              <div className="font-bold">{siteContent.contact.phone}</div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
